export const path = {
  createNotification: {
    route: "/notifications/create",
    link: () => path.createNotification.route,
  },
};
